export default __webpack_public_path__ + "static/media/explore-map.3939dc05.png";